import { factoryService, getFileRequest, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL, REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets enrollment status certificate from the sellers of the tender
 */
export const getTenderEnrollmentCertificate = factoryService(({ numAcquisition }) => {
  if (REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS === true || REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS === 'true') {
    return getJsonRequest(`
      ${REACT_APP_API_BASE_URL}/v2/proveedor/certificadohabilidad/licitacion/${numAcquisition}`)
  }
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v2/proveedor/certificadohabilidad/licitacion/${numAcquisition}`)
})

/**
 * Gets PDF enrollment status certificate from the sellers of the tender
 */
export const getTenderEnrollmentCertificatePdf = factoryService(({ numAcquisition }) => {
  if (REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS === true || REACT_APP_FEATURE_FLAG_TEMPORARY_UNIONS === 'true') {
    return getFileRequest(`${REACT_APP_API_BASE_URL}/v1/pdf/certificado/habilidad/licitacionv2/${numAcquisition}`)
  }
  return getFileRequest(`${REACT_APP_API_BASE_URL}/v1/pdf/certificado/habilidad/licitacion/${numAcquisition}`)
})

/**
 * Gets a seller's enrollment status certificate
 */
export const getSellerEnrollmentCertificate = factoryService(({ dni = undefined }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/proveedor/certificadohabilidad${dni !== undefined ? `/${normalizeDniSlashes(dni)}` : '/'}`
  )
})

/**
 * Gets a hability list
 **/
export const getHabilityDetailList = factoryService(({ dni, isForeign }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v3/proveedor/habilidad/${normalizeDniSlashes(dni)}/${isForeign}`)
})

/**
 * Gets validate recalculate ability button
 **/
export const validateButtonRecalculate = factoryService(({ dni }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/calculo-habilidad-proveedor/fecha-proximo-recalculo-proveedor/${normalizeDniSlashes(dni)}`
  )
})

/**
 * Adding to waiting list recalculate process
 **/
export const addingToWaitingListRecalculate = factoryService(({ dni }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/calculo-habilidad-proveedor/agregar-a-lista-espera-proveedor/${normalizeDniSlashes(dni)}`
  )
})

/**
 * Gets a PDF seller's enrollment status certificate
 */
export const getSellerEnrollmentCertificatePdf = factoryService(({ dni = undefined, isForeign = undefined }) => {
  return getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/pdf/certificado/habilidad/proveedor${dni !== undefined ? `/${normalizeDniSlashes(dni)}` : ''}${
      isForeign !== undefined ? `/${isForeign}` : ''
    }`
  )
})
